// shared
import LocationDetails from '../navPages/LocationDetails'

// recently updated
import LocationTasksCN from '../navPages/LocationTasksCN'

import LocationChat from '../navPages/LocationChat'
import LocationNotes from '../navPages/LocationNotes'
import LocationAnalytics from '../navPages/LocationDemographics'
import LocationMaps from '../navPages/LocationMaps'
import LocationImages from '../navPages/LocationImages'
import ProjectDocuments from '../../projects/navPages/ProjectDocuments'
import LocationAddPartners from '../components/LocationAddPartners'
import { ProjectFinancials } from 'features/Financials'
import {
	StickyNote,
	MessageSquare,
	Map,
	ListTodo,
	DollarSign,
	Info,
	BarChart3,
	Images,
	FileText,
} from 'lucide-react'
import routes from 'constants/routes'

const getLocationProjectPartnerRoutes = (id: string, projectId: string) => [
	{
		linkText: 'Tasks',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/tasks`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/tasks`,
		icon: ListTodo,
		component: LocationTasksCN,
	},
	{
		linkText: 'Notes ',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/notes`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/notes`,
		icon: StickyNote,
		component: LocationNotes,
	},
	{
		linkText: 'Chat',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/chat`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/chat`,
		icon: MessageSquare,
		component: LocationChat,
	},
	{
		linkText: 'Map',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/maps`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/maps`,
		icon: Map,
		component: LocationMaps,
	},
	{
		linkText: 'Financials',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/financials`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/financials`,
		icon: DollarSign,
		component: ProjectFinancials,
	},
	{
		linkText: 'Details',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/details`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/details`,
		icon: Info,
		component: LocationDetails,
	},

	{
		linkText: 'Demographics',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/analytics`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/analytics`,
		icon: BarChart3,
		component: LocationAnalytics,
	},
	{
		linkText: 'Images',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/images`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/images`,
		icon: Images,
		component: LocationImages,
	},
	{
		linkText: 'Documents',
		linkTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/files`,
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/files`,
		icon: FileText,
		component: ProjectDocuments,
	},

	/*
		Redirect routes
	*/

	{
		linkPattern: `${routes.LOCATIONS}/:id/projects/:projectId/addpartners`,
		component: LocationAddPartners,
	},

	{
		redirectFrom: `${routes.LOCATIONS}/:id/projects/:projectId`,
		redirectTo: `${routes.LOCATIONS}/${id}/projects/${projectId}/tasks`,
	},
]

export default getLocationProjectPartnerRoutes
